import { Breakpoint, MediaQueries } from '@philips-internal/oswald-ui-constants';
const breakpointToMedia = [
    [Breakpoint.XSM, MediaQueries.XSMALL],
    [Breakpoint.SM, MediaQueries.SMALL],
    [Breakpoint.MD, MediaQueries.MEDIUM],
    [Breakpoint.LG, MediaQueries.LARGE],
];
function getBreakpoint(windowObj = window) {
    const [breakpoint] = breakpointToMedia.find(([, value]) => windowObj.matchMedia(value).matches) ?? [Breakpoint.GLOBAL];
    return breakpoint;
}
export default getBreakpoint;
//# sourceMappingURL=get-breakpoint.js.map